/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Status_DueInputs */

const cs_gdpr_status_due = /** @type {(inputs: Gdpr_Status_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`K posouzení`)
};

const en_gdpr_status_due = /** @type {(inputs: Gdpr_Status_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To review`)
};

/**
* | output |
* | --- |
* | "To review" |
*
* @param {Gdpr_Status_DueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_status_due = /** @type {((inputs?: Gdpr_Status_DueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Status_DueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_status_due(inputs)
	return cs_gdpr_status_due(inputs)
});